export * from './star-rating.component';